import { useState } from 'react';
import { toast } from 'react-toastify';
import { unwrapResult } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

import { CustomAlert, CustomButton, Text } from '../../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../../shared/Helpers/functions';
import { BadgeCheckIcon } from '../../../../../../shared/Assets/svgIcons';
import { ButtonWrapper } from '../../../../../../components/StyledComponents';

import { DispatchProperties, useSelector } from '../../../../../../redux/store';
import { getTargets, masterOutTarget } from '../../../../../../redux/State/clientSlice/programTargetSlice';
import { TargetProperties } from '../../../../../../redux/API/ClientAPIHelpers/programTargetsProperties';

const MasterOut = ({ item }: { item: TargetProperties }) => {
	const [openMasterOut, setOpenMasterOut] = useState<boolean>(false);
	const dispatch = useDispatch<DispatchProperties>();
	const { id, programId } = item;
	const includeMastered = useSelector((state) => state.programTarget.includeMastered);

	const masterOutTargetHandler = () => {
		if (!id || !programId) return;

		dispatch(masterOutTarget({ id, programId }))
			.then(unwrapResult)
			.then(() => {
				dispatch(getTargets({ programId, includeMastered }));
				setOpenMasterOut(false);
				toast('Success');
			})
			.catch(errorNormalizer);
	};

	return (
		<>
			<div className="actionRow" onClick={() => setOpenMasterOut(true)}>
				<div className="actionIcon">
					<BadgeCheckIcon />
				</div>
				<div className="actionContent">
					<Text title="Master Out" type="psm" fontWeight="medium" />
				</div>
			</div>
			<CustomAlert
				title="Are you sure?"
				onClose={() => setOpenMasterOut(false)}
				open={openMasterOut}
				Content={() => (
					<ButtonWrapper>
						<CustomButton title="Master out target" onClick={masterOutTargetHandler} />
						<CustomButton title="Cancel" buttonType="secondaryGray" onClick={() => setOpenMasterOut(false)} />
					</ButtonWrapper>
				)}
			/>
		</>
	);
};

export default MasterOut;
